<template>
  <!-- The picked activity on its process's page (US 9369 + 9371): its own Edit, ⋯ and History, apart from the hero's,
       which are always the process's. Same card as a contract's header. -->
  <header class="pp-chead" qid="activity-head">
    <span class="pp-chead__icon"><font-awesome-icon icon="cube"/></span>

    <div class="pp-chead__main">
      <h2 qid="p-view-page-title">{{ activity.name }}</h2>
      <div class="pp-chead__meta">
        <span class="pp-scope is-kid">
          <font-awesome-icon icon="cube"/>{{ count > 1 ? $t('activity_head.activity_of', { index: index, count: count }) : $t('activity_head.activity') }}
        </span>
        <span v-if="!hasProcess" class="is-warn"><font-awesome-icon icon="exclamation-triangle"/> {{ $t('activity_head.no_process') }}</span>
        <span :class="{ 'is-warn': !owner }">{{ owner ? $t('vendor_merged.owner', { name: owner.name }) : $t('system_hero.no_owner') }}</span>
        <span v-if="countryNames"><font-awesome-icon icon="globe"/> {{ countryNames }}</span>
        <span v-for="tag in shownTags" :key="tag.id || tag.name_translated" :title="tag.name_translated"><font-awesome-icon icon="tag"/> {{ tag.name_translated | truncate(30) }}</span>
        <span v-if="hiddenTags">+{{ hiddenTags }}</span>
        <span v-if="activity.updated_at">{{ $t('activity_head.updated', { date: $options.filters.formatDate(activity.updated_at) }) }}</span>
        <span v-if="!activity.partition && getClient.parent"><font-awesome-icon icon="lock"/> {{ $t('systems_overview.from_workspace', { name: getClient.parent.name }) }}</span>
      </div>
    </div>

    <!-- History opens from the header instead of the tab bar, as on projects -->
    <button type="button"
            class="pp-btn"
            :class="{ on: historyOn }"
            v-b-tooltip.hover
            :title="$t('activities.tab.history')"
            qid="activity-open-history"
            @click="$emit('history')">
      <font-awesome-icon icon="history"/><span class="sr-only">{{ $t('activities.tab.history') }}</span>
    </button>
    <button v-if="canEdit"
            type="button"
            class="pp-btn"
            qid="edit-activity-button"
            @click="$emit('edit')">
      <font-awesome-icon icon="pen"/>{{ $t('system_hero.edit') }}
    </button>
    <b-dropdown right
                no-caret
                variant="link"
                toggle-class="pp-btn"
                menu-class="sx-menu"
                qid="activity-more">
      <template #button-content>
        <font-awesome-icon icon="ellipsis-h"/><span class="sr-only">{{ $t('system_hero.more') }}</span>
      </template>
      <b-dropdown-item v-if="canEdit" @click="$emit('edit')"><font-awesome-icon icon="pen"/>{{ $t('system_hero.menu.edit') }}</b-dropdown-item>
      <b-dropdown-item v-if="canMove" qid="activity-move" @click="$emit('move')"><font-awesome-icon icon="exchange-alt"/>{{ hasProcess ? $t('activity_head.menu.move') : $t('activity_head.menu.move_first') }}</b-dropdown-item>
      <b-dropdown-item qid="activity-print" @click="print"><font-awesome-icon icon="file-alt"/>{{ $t('system_hero.menu.export') }}</b-dropdown-item>
      <template v-if="canDelete">
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item link-class="is-danger" qid="delete-s-button" @click="$emit('delete')"><font-awesome-icon icon="trash-alt"/>{{ $t('system_hero.menu.delete') }}</b-dropdown-item>
      </template>
    </b-dropdown>
  </header>
</template>

<script>
  export default {
    name: 'ActivityHead',
    props: {
      activity: { type: Object, required: true },
      // Its place among the process's activities
      index: { type: Number, default: 1 },
      count: { type: Number, default: 1 },
      hasProcess: { type: Boolean, default: true },
      historyOn: { type: Boolean, default: false }
    },
    computed: {
      getClient() {
        return this.$store.state.client;
      },
      editable() {
        return !this.getClient.parent || this.activity.partition;
      },
      canEdit() {
        return this.isGranted([this.permissions.ACTIVITY_EDIT, this.permissions.ACTIVITY_EDIT_OWN], this.activity) && this.editable;
      },
      canMove() {
        return this.canEdit && this.isGranted(this.permissions.ACTIVITY_CREATE);
      },
      canDelete() {
        return this.isGranted([this.permissions.ACTIVITY_DELETE, this.permissions.ACTIVITY_DELETE_OWN], this.activity) && this.editable;
      },
      owner() {
        let users = this.activity.users || [];
        return users.find(user => user.owner || (user.pivot && user.pivot.owner)) || users[0] || null;
      },
      countryNames() {
        return (this.activity.countries_with_flag || []).map(country => country.name).join(', ');
      },
      tags() {
        return this.activity.tags_translated || [];
      },
      shownTags() {
        return this.tags.slice(0, 2);
      },
      hiddenTags() {
        return Math.max(this.tags.length - 2, 0);
      }
    },
    methods: {
      print() {
        window.print();
      }
    }
  };
</script>
